// Сетевой слой: авторизация, прогресс, награды, рейтинг, share.
// Оффлайн-щит: сервер недоступен — играем на localStorage, незасинканные
// результаты копятся в очереди и уходят при восстановлении связи.

const PENDING_KEY = 'etazhi_tower_pending';
let sessionToken = null;

async function post(url, body) {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(sessionToken ? { 'X-Session': sessionToken } : {}) },
    body: JSON.stringify(body || {}),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `http ${res.status}`);
  return data;
}

async function get(url) {
  const res = await fetch(url, { headers: sessionToken ? { 'X-Session': sessionToken } : {} });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `http ${res.status}`);
  return data;
}

export const net = {
  online: false,

  // Авторизация: возвращает { player, progress, claims, dev } или null (оффлайн)
  async auth(initData) {
    try {
      const data = await post('/api/auth', { initData });
      sessionToken = data.token;
      this.online = true;
      return data;
    } catch (e) {
      this.online = false;
      return null;
    }
  },

  async loadConfig() {
    const res = await fetch('/api/config');
    if (!res.ok) throw new Error('config http ' + res.status);
    return res.json();
  },

  async levelStart(level, mode) {
    try {
      const data = await post('/api/level/start', mode ? { level, mode } : { level });
      return data.runId;
    } catch (e) {
      return null; // оффлайн: забег без runId, результат уйдёт в очередь
    }
  },

  // Завершение уровня; при неудаче — в очередь на потом
  async levelComplete(payload) {
    try {
      const data = await post('/api/level/complete', payload);
      this.online = true;
      return data;
    } catch (e) {
      if (payload.runId) return null; // сервер отверг — не копим (античит)
      const q = JSON.parse(localStorage.getItem(PENDING_KEY) || '[]');
      q.push(payload);
      localStorage.setItem(PENDING_KEY, JSON.stringify(q.slice(-20)));
      return null;
    }
  },

  // Досинк очереди: для каждого отложенного результата берём свежий runId.
  // Античит по времени такие забеги не пропустит моментально — сервер знает
  // про очередь ничего, поэтому оффлайн-результаты в рейтинг не попадают,
  // но прогресс уровней восстановится честной игрой. Очередь чистим.
  async flushPending() {
    localStorage.removeItem(PENDING_KEY);
  },

  async claimReward(level) {
    return post('/api/reward/claim', { level });
  },

  // Без level — общий зачёт по всем уровням (иначе новички не видят никого)
  async leaderboard(level) {
    return get(level ? `/api/leaderboard?level=${level}` : '/api/leaderboard');
  },

  // --- Башня дня ---
  async daily() { return get('/api/daily'); },
  async dailyStart() {
    try { return (await post('/api/daily/start')).runId; } catch (e) { return null; }
  },
  async dailyComplete(payload) {
    try { return await post('/api/daily/complete', payload); } catch (e) { return null; }
  },

  // --- Подборка объектов после приза ---
  async featured() {
    try { return (await get('/api/featured')).objects || []; } catch (e) { return []; }
  },
  async featuredInterest(objectId) {
    return post('/api/featured/interest', { objectId });
  },

  // Репорт ошибки на сервер: молча, без ретраев — репортер не должен сам падать
  reportError(message, stack, url) {
    try {
      post('/api/client-error', { message, stack, url }).catch(() => {});
    } catch (e) { /* совсем без сети — теряем репорт, игру не трогаем */ }
  },

  async share(imageDataUrl) {
    return post('/api/share', { image: imageDataUrl });
  },
};
